import { Navigate, useLocation, useParams } from "react-router";
import { usePermissionsApi } from "@/api/use-landlord-api";

export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { landlordId } = useParams<{ landlordId: string }>();
  const { data: permissions, isLoading } = usePermissionsApi(landlordId || "");

  // While fetching, render nothing
  if (isLoading) return null;

  // If data is fetched but permissions are null/undefined or user is not admin, redirect
  if (!permissions?.admin) {
    return <Navigate replace to={`/app/${landlordId}/posts?unauthorized=1`} state={{ from: location }} />;
  }

  return <>{children}</>;
};
